/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InventoryCatalogCatalogStatusEnum = {
    Pending: 'PENDING',
    InQueue: 'IN_QUEUE',
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * Check if a given object implements the InventoryCatalog interface.
 */
export function instanceOfInventoryCatalog(value) {
    return true;
}
export function InventoryCatalogFromJSON(json) {
    return InventoryCatalogFromJSONTyped(json, false);
}
export function InventoryCatalogFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'title': json['title'] == null ? undefined : json['title'],
        'categoryBsr': json['categoryBsr'] == null ? undefined : json['categoryBsr'],
        'subcategoryBsr': json['subcategoryBsr'] == null ? undefined : json['subcategoryBsr'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'productType': json['productType'] == null ? undefined : json['productType'],
        'variationCount': json['variationCount'] == null ? undefined : json['variationCount'],
        'reviewRating': json['reviewRating'] == null ? undefined : json['reviewRating'],
        'reviewCount': json['reviewCount'] == null ? undefined : json['reviewCount'],
        'catalogInfoLastModifiedDate': json['catalogInfoLastModifiedDate'] == null ? undefined : (new Date(json['catalogInfoLastModifiedDate'])),
        'reviewsLastModifiedDate': json['reviewsLastModifiedDate'] == null ? undefined : (new Date(json['reviewsLastModifiedDate'])),
        'catalogStatus': json['catalogStatus'] == null ? undefined : json['catalogStatus'],
        'catalogQueuedAt': json['catalogQueuedAt'] == null ? undefined : (new Date(json['catalogQueuedAt'])),
        'asin': json['asin'] == null ? undefined : json['asin'],
        'marketplaceId': json['marketplaceId'] == null ? undefined : json['marketplaceId'],
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'seller': json['seller'] == null ? undefined : json['seller'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
    };
}
export function InventoryCatalogToJSON(json) {
    return InventoryCatalogToJSONTyped(json, false);
}
export function InventoryCatalogToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
        'imageUrl': value['imageUrl'],
        'title': value['title'],
        'categoryBsr': value['categoryBsr'],
        'subcategoryBsr': value['subcategoryBsr'],
        'brand': value['brand'],
        'productType': value['productType'],
        'variationCount': value['variationCount'],
        'reviewRating': value['reviewRating'],
        'reviewCount': value['reviewCount'],
        'catalogInfoLastModifiedDate': value['catalogInfoLastModifiedDate'] == null ? undefined : ((value['catalogInfoLastModifiedDate']).toISOString()),
        'reviewsLastModifiedDate': value['reviewsLastModifiedDate'] == null ? undefined : ((value['reviewsLastModifiedDate']).toISOString()),
        'catalogStatus': value['catalogStatus'],
        'catalogQueuedAt': value['catalogQueuedAt'] == null ? undefined : ((value['catalogQueuedAt']).toISOString()),
        'asin': value['asin'],
        'marketplaceId': value['marketplaceId'],
        'searchId': value['searchId'],
        'seller': value['seller'],
        'sourceType': value['sourceType'],
        'sourceId': value['sourceId'],
    };
}
